
import VueSlickCarousel from 'vue-slick-carousel'
import { Component, Vue, Prop, Emit } from 'nuxt-property-decorator'
import type { ProviderModel, RatingStatModel } from '@alao-frontend/erp-services'
import ProviderRatingCard from '~/components/providers/ProviderRatingCard.vue'
import { OnMounted } from '~/core/vue.types'

@Component({
  components: {
    VueSlickCarousel,
    ProviderRatingCard,
  },
})
export default class ProviderRatingCarousel extends Vue implements OnMounted {
  @Prop({ required: false, default: -1 })
  readonly selectedProvider!: number

  @Prop({ required: true })
  readonly feedbackRatingStats!: RatingStatModel[]

  @Prop({ required: true, default: () => ([]), type: Array })
  private readonly providersList!: ProviderModel[]

  private settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerPadding: '0px',
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: false,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          dots: false,
          initialSlide: 0,
        },
      },
    ],
  }

  private isMounted = false

  getProviderScores (providerId: number) {
    return this.feedbackRatingStats.find(scores => scores.provider_id === providerId) || {}
  }

  @Emit()
  onSlideChange (slideIdx: number) {
    return slideIdx
  }

  @Emit()
  onCTAClick (slug: string) {
    return slug
  }

  setSlideTo (index: number) {
    // TODO: Typing for goTo()
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.ratingsCarousel.goTo(index)
  }

  mounted () {
    this.isMounted = true

    if (this.selectedProvider === -1) { return }
    const index = this.providersList.map(p => p.id).indexOf(this.selectedProvider)

    if (index === -1) { return }

    this.$nextTick(() => {
      this.setSlideTo(index)
      this.onSlideChange(index)
    })
  }
}
